
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('line',{attrs:{"x1":"4.5","y1":"13.7929","x2":"13.7929","y2":"4.5","stroke":"#CFD8DD","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"0.5","y1":"13.7929","x2":"13.7929","y2":"0.5","stroke":"#CFD8DD","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"8.5","y1":"13.7929","x2":"13.7929","y2":"8.5","stroke":"#CFD8DD","stroke-linecap":"round"}}),_c('line',{attrs:{"x1":"12.5","y1":"13.7929","x2":"13.7929","y2":"12.5","stroke":"#CFD8DD","stroke-linecap":"round"}})])
          )
        }
      }
    